import { apiBaseUrl, apiKey } from '../env';

interface ApiOptions extends Omit<RequestInit, 'body'> {
  body?: Record<string, unknown>;
}

const api = async <T>(endpoint: string, opts: ApiOptions = {}) => {
  const { body, ...rest } = opts;

  const config: RequestInit = {
    method: 'GET',
    ...rest,
    headers: {
      'content-type': 'application/json',
      'x-api-key': apiKey,
      ...rest.headers,
    },
    ...(body !== undefined && { body: JSON.stringify(body) }),
  };

  const response = await fetch(`${apiBaseUrl}v4/${endpoint}`, config);

  if (!response.ok) {
    const errorMessage = await response.text();
    throw new Error(`HTTP error. Status: ${response.status}. Message: ${errorMessage}`);
  }

  const data: T = await response.json();
  return data;
};

export default api;
